import React from 'react';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ActivityDetailsByActionType } from '../../config/reports/performance-rule-executed-actions/ActivityDetailsByActionType';

const messageConfig = ({ actionType, additionalData }) => {
    const changeType = additionalData?.budgetAdditionalData?.changeType;
    const messageId = changeType
        ? `performance.rule.executed.actions.report.actionType.details.${actionType}.${changeType}`
        : `performance.rule.executed.actions.report.actionType.details.${actionType}`;

    return ActivityDetailsByActionType[messageId];
};

export const PerformanceRuleExecutedActionActivityDetailsCellRenderer = ({
    data: {
        affectedEntity: { id, name },
        actionType,
        additionalData,
    },
}) => {
    const changeValue = additionalData?.budgetAdditionalData?.changeValue;
    const changeType = additionalData?.budgetAdditionalData?.changeType;
    const { currency } = useAccount();
    return (
        <FormattedMessage
            {...messageConfig({ actionType, additionalData })}
            values={{
                name,
                id,
                changeValue,
                changeType,
                currency,
            }}
        />
    );
};
